//
//
//
//
//
//
//
//
//
//
//

export default {
	data(){
		return{
			
		}
	},
	methods:{
		getzxrm(){
			return this.$store.dispatch("getzxrm");
		},
	},
	mounted(){
		this.getzxrm()
	},
	computed:{
		list(){
			if(this.$store.getters.getzxrm) {
				return this.$store.getters.getzxrm.data.info
			}
		}
	}
}



// WEBPACK FOOTER //
// ./src/components/search/hotSearch.vue